<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a
          class="sub-nav"
          @click="$router.push('/gestion-de-usuarios/perfil')"
          >{{ $t("users.userArea") }}</a
        >
        <a
          style="font-weight: bold; color: #222222 !important"
          @click="$router.push('/gestion-de-usuarios/')"
          class="sub-nav"
        >
          {{ $t("users.userManagement") }}
        </a>
      </v-container>
    </v-toolbar>
    <v-container class="py-10">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("users.userManagement") }}
          </h1>
        </v-col>
        <v-col>
          <v-btn
            depressed
            :color="entityConfig.primaryColor"
            class="float-end my-5"
            :style="`color: ${entityConfig.secondaryColor}`"
            @click="addUser"
          >
            {{ $t("users.newUser") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row style="align-items: center">
        <v-col sm="8">
          <h2 class="text-h5 font-weight-light">
            {{ $t("users.list") }}
          </h2>
        </v-col>
        <v-col sm="4">
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="downloadExcel"
            class="float-end m-2"
          >
            <v-icon left> mdi-microsoft-excel </v-icon>
            Excel
          </v-btn>
          <v-btn
            plain
            :color="entityConfig.primaryColor"
            @click="print"
            class="float-end m-2"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("supplierData.print") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row class="pb-10">
        <v-col>
          <v-divider
            :hidden="!noData"
            :color="entityConfig.primaryColor"
          ></v-divider>
          <error-table :erroCode="valCode" :hidden="!noData" />

          <v-data-table
            :hidden="noData"
            fixed-header
            class="firt-col-right-margin"
            no-data-text="No hay datos que mostrar"
            :headers="headers"
            :items="users"
            hide-default-footer
          >
          <template v-slot:item.principal="{ item }">
            <v-chip right v-if="item.isPrincipalUser == true"
                class="ma-2"
                color="green"
                text-color="white"
              >
                <span>{{ $t("users.principal") }}</span>
              </v-chip>
          </template>

            <template v-slot:item.notVerified="{ item }">
             
              <v-tooltip left v-if="item.status == 'No verificado'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="grey darken-1" dark v-bind="attrs" v-on="on">
                    mdi-account-clock-outline
                  </v-icon>
                </template>
                <span>{{ $t("users.porConfirmar") }}</span>
              </v-tooltip>
             
              <v-tooltip left v-if="item.status == 'Bloqueado'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="grey darken-1" dark v-bind="attrs" v-on="on">
                    mdi-account-lock-outline
                  </v-icon>
                </template>
                <span>{{ $t("users.bloqueado") }}</span>
              </v-tooltip>

            

            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                :color="entityConfig.primaryColor"
                class="ml-4 float-end"
                @click="deleteItem(item)"
              >
                mdi-delete-outline
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <user-delete-dialog
        :user="currentUser"
        :visible="deleteDialog"
        @closed="deleteDialog = !deleteDialog"
        @confirmed="confirmDelete"
      ></user-delete-dialog>
    </v-container>
    <overlay :visible="spinner"></overlay>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import UserDeleteDialog from "./delete_dialog.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";
import xlsx from "json-as-xlsx";
import ErrorTable from "../../components/layouts/error-table.vue";

export default {
  components: {
    UserDeleteDialog,
    LayoutAuth,
    Overlay,
    ErrorTable,
  },
  data() {
    return {
      noData: false,
      valCode: 0,
      entityConfig: {},
      currentUser: {},
      spinner: true,
      deleteDialog: false,
      headers: [
        {
          text: "Nombre / Alias",
          sortable: false,
          width: "15%",
          value: "alias",
        },
        {
          text: "Email",
          sortable: false,
          value: "email",
           width: "25px",
        },

        {
          sortable: false,
          value: "principal",
        },

        {
          text: "",
          sortable: false,
          value: "notVerified",
          width: "20px",
        },
        {
          text: "",
          sortable: false,
          value: "actions",
          width: "20px",
        },
      ],
      users: [],
    };
  },
  mounted() {
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.getUsers();
    this.entityConfig = this.$store.state.entityConfig.config;
  },
  methods: {
    print() {
      window.print();
    },
    downloadExcel() {
      let data = [
        {
          sheet: "Users",
          columns: [
            { label: "Alias", value: "alias" },
            { label: "Email", value: "email" },
          ],
          content: this.users,
        },
      ];
      let settings = { fileName: this.$t("users.list") };
      xlsx(data, settings);
    },
    deleteItem(item) {
      this.deleteDialog = !this.deleteDialog;
      this.currentUser = item;
    },
    confirmDelete(user) {
      this.spinner = true;
      Api.delete(`/usuarios/${user.id}`)
        .then(() => {
          this.$toast.success("Usuario eliminado, verifique su correo");
          this.deleteDialog = !this.deleteDialog;
          this.getUsers();
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    getUsers() {
      this.spinner = true;
      Api.get("/usuarios")
        .then((response) => {
          this.users = response.data.response;
          if (this.users == "") {
            this.noData = true;
            this.valCode = 709;
          }
        })
        .catch((error) => {
          this.valCode = error.response.data.code;
          this.noData = true;
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    addUser() {
      sessionStorage.removeItem("userConfirm");
      this.$router.push("/gestion-de-usuarios/add");
    },
  },
};
</script>
